import {GetterTree} from 'vuex';
import {RootState} from '@/store';

export const getters:GetterTree<RootState, RootState> = {

    appIsIdle(state): boolean {
        return state.idleVue.isIdle
    }
}
